<ion-content scrollY="false">
  <ion-list lines="full">

    @if (printer_paper_sizes && printer_paper_sizes.length > 0) {
      @if (permissionService.isPermitted('pos-sell-order-confirmation-print-invoice') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
        <ion-item button="true" id="print_receipt" detail="true">
          <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Invoice@if (order.payment_status != 'unpaid') {
          / receipt
        }</ion-label>
      </ion-item>
      <ion-popover trigger="print_receipt" [dismissOnSelect]="true" side="end">
        <ng-template>
          <ion-content>
            <ion-list lines="full">
              @if (printer_paper_sizes.includes('a4')) {
                <ion-item button="true" (click)="printInvoice('a4')">
                  <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                </ion-item>
              }
              @if (printer_paper_sizes.includes('thermal')) {
                <ion-item button="true" (click)="printInvoice('thermal')">
                  <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                </ion-item>
              }
            </ion-list>
          </ion-content>
        </ng-template>
      </ion-popover>
    }
    @if (permissionService.isPermitted('pos-sell-order-confirmation-print-invoice') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printInvoice('a4')">
        <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Invoice@if (order.payment_status != 'unpaid') {
        / receipt
      }</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-invoice') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" (click)="printInvoice('thermal')">
      <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Invoice@if (order.payment_status != 'unpaid') {
      / receipt
    }</ion-label>
  </ion-item>
}
@if (order_has_tickets) {
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-tickets') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" id="print_tickets" detail="true">
      <ion-label><fa-icon [icon]="['fal', 'ticket']" size="lg" [fixedWidth]="true"></fa-icon>Tickets</ion-label>
    </ion-item>
    <ion-popover trigger="print_tickets" [dismissOnSelect]="true" side="end">
      <ng-template>
        <ion-content>
          <ion-list lines="full">
            @if (printer_paper_sizes.includes('a4')) {
              <ion-item button="true" (click)="printTickets('a4')">
                <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
              </ion-item>
            }
            @if (printer_paper_sizes.includes('thermal')) {
              <ion-item button="true" (click)="printTickets('thermal')">
                <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
              </ion-item>
            }
          </ion-list>
        </ion-content>
      </ng-template>
    </ion-popover>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-tickets') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" (click)="printTickets('a4')">
      <ion-label><fa-icon [icon]="['fal', 'tickets-simple']" size="lg" [fixedWidth]="true"></fa-icon>Tickets</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-tickets') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" (click)="printTickets('thermal')">
      <ion-label><fa-icon [icon]="['fal', 'tickets-simple']" size="lg" [fixedWidth]="true"></fa-icon>Tickets</ion-label>
    </ion-item>
  }
}
@if (order_has_gift_vouchers) {
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-gift-vouchers') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" id="print_gift_vouchers" detail="true">
      <ion-label><fa-icon [icon]="['fal', 'gift']" size="lg" [fixedWidth]="true"></fa-icon>Gift voucher</ion-label>
    </ion-item>
    <ion-popover trigger="print_gift_vouchers" [dismissOnSelect]="true" side="end">
      <ng-template>
        <ion-content>
          <ion-list lines="full">
            @if (printer_paper_sizes.includes('a4')) {
              <ion-item button="true" (click)="printGiftVouchers('a4')">
                <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
              </ion-item>
            }
            @if (printer_paper_sizes.includes('thermal')) {
              <ion-item button="true" (click)="printGiftVouchers('thermal')">
                <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
              </ion-item>
            }
          </ion-list>
        </ion-content>
      </ng-template>
    </ion-popover>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-gift-vouchers') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" (click)="printGiftVouchers('a4')">
      <ion-label><fa-icon [icon]="['fal', 'gift']" size="lg" [fixedWidth]="true"></fa-icon>Gift voucher</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-gift-vouchers') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
    <ion-item button="true" (click)="printGiftVouchers('thermal')">
      <ion-label><fa-icon [icon]="['fal', 'gift']" size="lg" [fixedWidth]="true"></fa-icon>Gift voucher</ion-label>
    </ion-item>
  }
}
@if (printer_paper_sizes.includes('a4')) {
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-delivery-note') && (order && order.shipping_address)) {
    <ion-item button="true" (click)="printDeliveryNote()">
      <ion-label><fa-icon [icon]="['fal', 'file-contract']" size="lg" [fixedWidth]="true"></fa-icon>Delivery note</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-collection-note') && (order && order.pickup)) {
    <ion-item button="true" (click)="printCollectionNote()">
      <ion-label><fa-icon [icon]="['fal', 'file-contract']" size="lg" [fixedWidth]="true"></fa-icon>Collection note</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-xero-invoice') && (order && order.xero_invoice_id && !on_device)) {
    <ion-item button="true" (click)="printXeroInvoice()">
      <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Xero invoice</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-order-confirmation-print-packing-slip') && (order && order.fulfillment_status != 'fulfilled' && order.fulfillable == true)) {
    <ion-item button="true" (click)="printPackingSlip()">
      <ion-label><fa-icon [icon]="['fal', 'clipboard-list-check']" size="lg" [fixedWidth]="true"></fa-icon>Packing slip</ion-label>
    </ion-item>
  }
}
}

</ion-list>
</ion-content>
